import { createSelector } from 'reselect';
import { schema } from 'normalizr';
import moment from 'moment-timezone';
import memoize from 'lodash/memoize';
import { Participant } from '@app/api';
import {
  PARTICIPANT_ENTITY_NAME,
  participantLinkedEntities,
  participantSchema,
} from './definitions';
import {
  createAllEntitiesSelector,
  createDenormalizeSelector,
  entitiesSelector,
} from '../modules/entities';
import { ParticipantGlobalState, PARTICIPANT_MODULE_KEY } from './reducer';

const participantIdsSelector = (
  state: ParticipantGlobalState,
  panelId: string | undefined,
): string[] =>
  (panelId && state[PARTICIPANT_MODULE_KEY].participantByPanel[panelId]) || [];

export const selectFastParticipants = createSelector(
  participantIdsSelector,
  (state: any) => entitiesSelector(state, PARTICIPANT_ENTITY_NAME),
  (ids, entities) => {
    if (!entities) {
      return [];
    }
    return ids.map((id) => entities[id]);
  },
);

export const selectParticipantByPanelId = createSelector(
  createAllEntitiesSelector<Participant>(
    PARTICIPANT_ENTITY_NAME,
    participantLinkedEntities,
    new schema.Array(participantSchema),
  ),
  (_: any, id?: string) => id,
  (participants: Participant[], id?: string): Participant[] => {
    if (!id) {
      return [];
    }
    return participants
      .filter((p: Participant) => p.panelId === id)
      .sort((a, b) => {
        return moment(b.createdAt).diff(a.createdAt);
      });
  },
) as any;

export const participantByIdSelector = createDenormalizeSelector<Participant>(
  participantSchema,
  participantLinkedEntities,
);

export const createParticipantByIdSelector = memoize(
  (id?: string) =>
    (state: any): Participant | undefined =>
      id ? participantByIdSelector(state, id) : undefined,
);
